<template>
  <b-form-group :label="label">
    <multiselect
      :value="computedValue"
      :options="myOptions"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :placeholder="placeholder"
      label="designation"
      track-by="id"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @select="callback"
      :disabled="disabled"
    >
      <span slot="noResult">Nada encontrado</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import httpRda from "../../http-rda";

export default {
  props: {
    placeholder: {
      default: "Todos",
      type: String,
    },
    selected: { default: null },
    disabled: { default: false },
    label: {
      type: String,
      default: "Turmas",
    },
    value: {},
    callback: {},
    cycle: null,
    yearsback: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      options: "",
      classrooms: [],
    };
  },

  mounted() {
    if (this.selected !== null && this.selected !== undefined) {
      this.value = this.selected;
    }
  },

  watch: {
    cycle(newValue) {
      this.getClassrooms(newValue);
    },
  },
  created() {
    this.getClassrooms();
  },
  methods: {
    getClassrooms() {
      const params = {
        cycleId: this.cycle,
        yearsback: this.yearsback,
      };

      if (params.cycle === -1) {
        delete params.cycle;
      }
      httpRda
        .get("/classrooms-index", { params })
        .then((response) => {
          this.classrooms = response.data.classrooms;
        })
        .catch((error) => {
          return error;
        });
    },
    clearAll() {
      this.classrooms = [];
    },
  },
  computed: {
    myOptions() {
      if (!this.classrooms.length) return [];

      return [...this.classrooms, { designation: "Todos", id: -1 }];
    },
    computedValue() {
      if (typeof this.value === "number") {
        return this.classrooms.find((c) => c.id == this.value);
      } else {
        return this.value;
      }
    },
  },
};
</script>
